import { lazyLoad } from '../../index'
import RouterView from '@/components/RouterView'

import BoardRoutes from './boardRoutes'
import CardRoutes from './cardRoutes'

export default {
  path: 'trello',
  redirect: 'trello/boards',
  component: lazyLoad('Admin/Trello/layout'),
  children: [
    ...BoardRoutes,
    CardRoutes
  ]
}
